import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidOddOneOut } from '../../../../../mechanics/rid-odd-one-out/rid-odd-one-out';

@Component({
  selector: 'app-odd-one-out-sentences-page',
  imports: [RidOddOneOut],
  templateUrl: './odd-one-out-sentences-page.html',
})
export class OddOneOutSentencesPage {
  protected readonly $router = inject(Router);
}
